"use client";

export default function RemoveBgSkeleton() {
  return (
    <section className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center gap-4">
        <div className="h-6 w-32 rounded-full bg-white/10" />
        <div className="h-10 w-64 rounded-full bg-white/10" />
        <div className="h-4 w-80 rounded-full bg-white/10" />
      </div>

      <div className="mt-12 space-y-10">
        <div className="h-64 rounded-3xl bg-white/5" />
        <div className="h-80 rounded-3xl bg-white/5" />
        <div className="h-40 rounded-3xl bg-white/5" />
      </div>
    </section>
  );
}
